import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import InfoPanel from '../components/InfoPanel'
import { STATUS } from '../components/InfoPanel'
import PoiInfo from './PoiInfo'
import StepInfo from './StepInfo'
import WaypointInfo from './WaypointInfo'
import AccommodationInfo from './AccommodationInfo'

import { useUrlParams } from '../hooks'
import { useSettings } from '../slices/settings'
import { setInfoPanel, useInfoPanel, useViewport, VIEWPORT_TYPE } from '../slices/ui'

export const InfoPanelMaxHeigth = () => {
    return Math.min(450, parseInt(window.innerHeight * 2 / 3))
    //return parseInt(window.innerWidth) > 430 ? Math.min(650, parseInt(window.innerHeight * 2/3)) : parseInt(window.innerHeight) - 240;
}

const InfoPanelView = (props) => {
  const dispach = useDispatch()
  const { route_id, trail_id } = useUrlParams(['route_id', 'trail_id'])
  const [maxHeight, setMaxHeigth] = useState()
  const infoPanel = useInfoPanel()
  const { zoom } = useSettings()
  //const defaultStatus = useViewport() === VIEWPORT_TYPE.MOBILE ? STATUS.MINIMIXED : STATUS.OPEN

  useEffect(() => {
    const setPanelSize = () => {
      setMaxHeigth(InfoPanelMaxHeigth())
    }
    window.addEventListener('resize', setPanelSize)
    setPanelSize()
    return () => window.removeEventListener('resize', setPanelSize)
  }, [])

  const onInfopanelClose = useCallback(() => {
    dispach(setInfoPanel(null))
  }, [dispach])

  const inner = useMemo(() => {
    const type = infoPanel ? infoPanel.type : null
    const args = Object.assign({}, infoPanel, {route_id: route_id, trail_id:trail_id})
    switch (type) {
      case 'step':
        return <StepInfo {...args}/>
      case 'waypoint':
        return <WaypointInfo {...args}/>
      case 'poi':
        return <PoiInfo {...args}/>
      case 'accommodation':
        return <AccommodationInfo {...args}/>
      default:
        return null
    }
  }, [infoPanel, trail_id, route_id])

  return (
      <InfoPanel className="pwa__mappanel__info"
                 onClose={onInfopanelClose}
                 defaultStatus={STATUS.OPEN}
                 maxHeight={maxHeight}
                 minHeigth={225 * zoom}>
        {inner}
      </InfoPanel>
  )
}

export default InfoPanelView
